// Module
var code = "<ui-view></ui-view>\n";
// Exports
export default code;